import { render, staticRenderFns } from "./squareModel.vue?vue&type=template&id=37545c1a&scoped=true&"
import script from "./squareModel.vue?vue&type=script&lang=js&"
export * from "./squareModel.vue?vue&type=script&lang=js&"
import style0 from "./squareModel.vue?vue&type=style&index=0&id=37545c1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37545c1a",
  null
  
)

export default component.exports